import * as React from "react";
import { forwardRef } from "react";
const SvgCollapseDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "128pt", height: "128pt", viewBox: "0 0 128 128", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { transform: "scale(2.56)", d: "m16 21.159 9.0881 8.6685 9.2484-8.8272", fill: "none", stroke: "#00abe6", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCollapseDown);
export { ForwardRef as ReactComponent };
